export const buildUrl = (src, external = false, domain = '') => `${external ? '' : domain}${src}`;
//# sourceMappingURL=build-url.js.map